import React, { createContext, useState, useContext } from "react";
import { initialProperties } from "../utils/initialProperties";

const PropertyContext = createContext(undefined);

export const usePropertyContext = () => {
  const context = useContext(PropertyContext);
  if (!context) {
    throw new Error(
      "usePropertyContext must be used within a PropertyProvider"
    );
  }
  return context;
};

export const PropertyProvider = ({ children }) => {
  const [properties, setProperties] = useState(initialProperties);

  const addProperty = (property) => {
    const newProperty = { ...property, id: Date.now().toString() };
    setProperties([...properties, newProperty]);
  };

  const updateProperty = (id, updatedProperty) => {
    setProperties(
      properties.map((p) => (p.id === id ? { ...p, ...updatedProperty } : p))
    );
  };

  const deleteProperty = (id) => {
    setProperties(properties.filter((p) => p.id !== id));
  };

  return (
    <PropertyContext.Provider
      value={{ properties, addProperty, updateProperty, deleteProperty }}
    >
      {children}
    </PropertyContext.Provider>
  );
};
